import { ClientBranding } from '@brands/services/identity/types/UserProfile';

const BRANDING_CSS_VARS = [
  '--primary-color',
  '--button-color',
  '--button_hover_color',
  '--text_color',
  '--font-family-base',
  '--secondary_color',
] as const;

/**
 * Pushes client branding onto the CSS custom properties the app actually
 * reads live. An inline style on documentElement always wins over any
 * :root/body stylesheet rule, regardless of selector specificity, so it
 * doesn't matter that --secondary_color is only ever declared once in :root.
 *
 * Passing null clears any branding a previous call left as an inline style —
 * removeProperty falls back to the stylesheet's own :root value. Callers
 * rely on this to reset the DOM when the current view isn't patient-facing.
 */
export const applyClientBranding = (clientBranding: ClientBranding | null): void => {
  if (!clientBranding) {
    BRANDING_CSS_VARS.forEach((cssVar) => document.documentElement.style.removeProperty(cssVar));
    return;
  }

  document.documentElement.style.setProperty('--primary-color', clientBranding.primary_color);
  document.documentElement.style.setProperty('--button-color', clientBranding.button_color);
  if (clientBranding.button_hover_color) {
    document.documentElement.style.setProperty('--button_hover_color', clientBranding.button_hover_color);
  } else {
    document.documentElement.style.removeProperty('--button_hover_color');
  }
  document.documentElement.style.setProperty('--text_color', clientBranding.text_color);
  document.documentElement.style.setProperty('--font-family-base', clientBranding.font_family);
  document.documentElement.style.setProperty('--secondary_color', clientBranding.secondary_color);
};
